import { FormComponentProps } from "components/Form/components/FormComponentProps";
import { Input } from "components/Form/components/Input/Input";
import { Url } from "components/Form/components/Url/Url";
import { getRelativeUrl } from "utils/service";

export const SettingReferencesFormComponent = ({
    input,
    meta,
    fieldProps,
    fieldAttr,
}: FormComponentProps) => {
    const lockedExecution = input.value?.execution;
    return (
        <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
            <div className="settingReferences">
                {lockedExecution && (
                    <div className="urlWrapper" key={lockedExecution.id}>
                        <Url
                            isReadOnly={true}
                            url={getRelativeUrl("execution", lockedExecution.id)}
                            text={lockedExecution.name}
                            isOpenLinkButtonShown
                            id={lockedExecution.id}
                        />
                    </div>
                )}
            </div>
        </Input>
    );
};
